import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import { defineComponent as _defineComponent } from 'vue';
import VSelect from 'vue-select';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import AzModal from '~/components/_next/molecules/AzModal.vue';
import LocaleIcon from '~/components/_next/atoms/AzFlagIcon.vue';
import InformationBox from '~/components/Molecules/InformationBox.vue';
import InformationItem from '~/components/Molecules/InformationItem.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { AZ_COUNTRY_COOKIE } from '~/constants/localization';
import { getCountryByCode, getCountryLabelByCode, getDefaultCountryByLocale } from '~/utils/localization';
import { useLocalization } from '~/composables/_next/useLocalization';
import { useLocaleSwitcher } from '~/composables/_next/useLocaleSwitcher';
import { useNavigatorLanguage } from '@vueuse/core';
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalLocalizationChoiceOrganism',
  setup: function setup(__props, _ref) {
    var _azClientCountryCooki;
    var expose = _ref.expose;
    var COOKIE_MAX_AGE = 6 * 30 * 24 * 60 * 60; // 6 months (approximately)

    var _useLocaleSwitcher = useLocaleSwitcher(),
      handleLoadingUpdate = _useLocaleSwitcher.handleLoadingUpdate,
      selectLocale = _useLocaleSwitcher.selectLocale,
      updateLocalization = _useLocaleSwitcher.updateLocalization,
      resetUrlToDefault = _useLocaleSwitcher.resetUrlToDefault,
      isLocalizationUpdating = _useLocaleSwitcher.isLocalizationUpdating,
      localizedUrl = _useLocaleSwitcher.localizedUrl;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n,
      $trackers = _useNuxt2App.$trackers;
    var _useLocalization = useLocalization(),
      country = _useLocalization.country,
      currentCurrency = _useLocalization.currency,
      locale = _useLocalization.locale,
      locales = _useLocalization.locales;
    var _useNavigatorLanguage = useNavigatorLanguage(),
      language = _useNavigatorLanguage.language;
    var _useShippingCountry = useShippingCountry(),
      setCountryCode = _useShippingCountry.setCountryCode,
      availableCountries = _useShippingCountry.availableCountries;
    var localeModalOpened = useCookie('country-modal-opened', {
      watch: 'shallow',
      maxAge: COOKIE_MAX_AGE
    });
    var azClientCountryCookie = useCookie(AZ_COUNTRY_COOKIE);
    var hasLocaleOrCountryChanged = ref(false);
    var modalRef = ref(null);
    var modalScenario = ref('standard');
    var chosenCountry = ref(getCountryByCode(country));
    var azClientCountry = ref((_azClientCountryCooki = azClientCountryCookie.value) !== null && _azClientCountryCooki !== void 0 ? _azClientCountryCooki : getDefaultCountryByLocale(locale));
    var deliveryCountryByIpLabel = computed(function () {
      return getCountryLabelByCode(azClientCountry.value);
    });
    var availableLanguagesDisplayed = computed(function () {
      return locales.map(function (locale) {
        return {
          code: locale.code,
          label: locale.label
        };
      }).sort(function (a, b) {
        return a.code.localeCompare(b.code);
      });
    });
    var chosenLocale = ref(getLocale(locale));
    function closeModal() {
      if (!isLocalizationUpdating.value) {
        modalRef.value.modal.close();
      }
    }
    function setCurrentCountry(country) {
      setCountryCode(country.name);
      hasLocaleOrCountryChanged.value = true;
    }
    function filterBy(_, label, search) {
      var translatedLabel = i18n.t(label) || '';
      var lowerLabel = translatedLabel.toLowerCase();
      var lowerSearch = search.toLowerCase();
      return lowerLabel.startsWith(lowerSearch);
    }
    function doesCountryMatch() {
      return azClientCountry.value === country;
    }
    function doesLocaleMatch() {
      if (!process.client) return true;
      var browserLocale = language.value;
      if (browserLocale.includes('-')) {
        browserLocale = browserLocale.split('-')[0];
      }
      var localeMatch = browserLocale === locale;
      return localeMatch;
    }
    function isBrowserLocaleAvailable() {
      var browserLocale = language.value.split('-')[0];
      return availableLanguagesDisplayed.value.some(function (lang) {
        return lang.code === browserLocale;
      });
    }
    function getLocale(localeToGet) {
      return availableLanguagesDisplayed.value.find(function (lang) {
        return lang.code === localeToGet;
      });
    }
    function setCurrentLocale(locale) {
      chosenLocale.value = locale;
      selectLocale(chosenLocale.value);
      hasLocaleOrCountryChanged.value = true;
    }
    var localeErrorMessage = computed(function () {
      var _route$name;
      if (localizedUrl.value === '/' && !(route !== null && route !== void 0 && (_route$name = route.name) !== null && _route$name !== void 0 && _route$name.includes('index')) && !isLocalizationUpdating.value) {
        return i18n.t('modals.locale-choice.text.translationNotAvailable');
      }
      return '';
    });
    function confirmChoices() {
      if (hasLocaleOrCountryChanged.value) {
        $trackers.gtm.pushEvent('change_language', {
          event: 'generic_event',
          event_category: 'engagement',
          event_action: 'change',
          event_label: 'language',
          event_name: 'change_language',
          country: chosenCountry.value.name,
          currency: currentCurrency,
          language: chosenLocale.value.code
        });
        handleLoadingUpdate(true);
        updateLocalization(chosenCountry.value.name, chosenLocale.value);
        if (modalScenario.value === 'auto-suggest') {
          localeModalOpened.value = 'true';
        }
        return;
      }
      closeModal();
    }
    function handleCloseEvent() {
      chosenCountry.value = getCountryByCode(country);
      chosenLocale.value = getLocale(locale);
      resetUrlToDefault();
      if (modalScenario.value === 'auto-suggest') {
        modalScenario.value = 'standard';
        localeModalOpened.value = 'true';
      }
    }
    onMounted(function () {
      var countryMatch = doesCountryMatch();
      var localeMatch = doesLocaleMatch();
      var isLocaleAvailable = isBrowserLocaleAvailable();
      if (countryMatch && localeMatch || !isLocaleAvailable || localeModalOpened.value) {
        return;
      }
      modalScenario.value = 'auto-suggest';
      modalRef.value.modal.showModal();
      $trackers.gtm.pushEvent('store_switcher_modal_opened', {
        event: 'generic_event',
        event_category: 'engagement',
        event_action: 'change',
        event_label: 'store_switcher_modal_opened',
        event_name: 'store_switcher_modal_opened',
        country: country,
        azClientCountry: azClientCountry.value,
        currency: currentCurrency,
        language: chosenLocale.value,
        trigger: 'country-mismatch'
      });
      if (!countryMatch) {
        chosenCountry.value = getCountryByCode(azClientCountry.value);
        hasLocaleOrCountryChanged.value = true;
      }
      if (!localeMatch) {
        var splitLanguage = language.value.split('-')[0];
        var matchedLocale = getLocale(splitLanguage);
        if (matchedLocale) {
          setCurrentLocale(matchedLocale);
        }
      }
    });
    expose({
      modalRef: modalRef
    });
    return {
      __sfc: true,
      COOKIE_MAX_AGE: COOKIE_MAX_AGE,
      handleLoadingUpdate: handleLoadingUpdate,
      selectLocale: selectLocale,
      updateLocalization: updateLocalization,
      resetUrlToDefault: resetUrlToDefault,
      isLocalizationUpdating: isLocalizationUpdating,
      localizedUrl: localizedUrl,
      isMobile: isMobile,
      route: route,
      i18n: i18n,
      $trackers: $trackers,
      country: country,
      currentCurrency: currentCurrency,
      locale: locale,
      locales: locales,
      language: language,
      setCountryCode: setCountryCode,
      availableCountries: availableCountries,
      localeModalOpened: localeModalOpened,
      azClientCountryCookie: azClientCountryCookie,
      hasLocaleOrCountryChanged: hasLocaleOrCountryChanged,
      modalRef: modalRef,
      modalScenario: modalScenario,
      chosenCountry: chosenCountry,
      azClientCountry: azClientCountry,
      deliveryCountryByIpLabel: deliveryCountryByIpLabel,
      availableLanguagesDisplayed: availableLanguagesDisplayed,
      chosenLocale: chosenLocale,
      closeModal: closeModal,
      setCurrentCountry: setCurrentCountry,
      filterBy: filterBy,
      doesCountryMatch: doesCountryMatch,
      doesLocaleMatch: doesLocaleMatch,
      isBrowserLocaleAvailable: isBrowserLocaleAvailable,
      getLocale: getLocale,
      setCurrentLocale: setCurrentLocale,
      localeErrorMessage: localeErrorMessage,
      confirmChoices: confirmChoices,
      handleCloseEvent: handleCloseEvent,
      VSelect: VSelect,
      AzButton: AzButton,
      AzLoader: AzLoader,
      AzModal: AzModal,
      LocaleIcon: LocaleIcon,
      InformationBox: InformationBox,
      InformationItem: InformationItem,
      AzIcon: AzIcon
    };
  }
});